import * as React from 'react'
import { Dropdown } from '@lightspeed/design-system-react'
import { CUSTOMER_FIELD, PartialCustomerGroup } from './types'

interface CustomerGroupsDropdownProps {
  // group.id used to set the selected value
  group?: PartialCustomerGroup | undefined
  customerGroups: PartialCustomerGroup[]
  onContactChange: (event: React.ChangeEvent<HTMLInputElement>) => void
}

/**
 * Dropdown to select a customer group
 */
export const CustomerGroupsDropdown: React.FC<CustomerGroupsDropdownProps> = ({
  group,
  customerGroups,
  onContactChange,
}) => {
  const handleSelect = (group: PartialCustomerGroup | undefined) => {
    const syntheticEvent = ({
      target: {
        name: CUSTOMER_FIELD.GROUP,
        value: group ?? undefined,
      },
      preventDefault: () => {},
    } as unknown) as React.ChangeEvent<HTMLInputElement>
    onContactChange(syntheticEvent)
  }

  return (
    <Dropdown
      placeholder="Select customer group"
      showSuggestionFooter={false}
      name={CUSTOMER_FIELD.GROUP}
      value={group?.id || customerGroups[0]?.id}
      items={customerGroups}
      onSelectCallback={handleSelect}
      required
    />
  )
}
